import React, { useState } from "react";
import '../assets/css/install-widget-popup.css';

const InstallWidgetPopup = ({ setIsInstallWidgetPopupOpen, template }) => {
    const [copySuccess, setCopySuccess] = useState(false);

    const handleClosePopup = () => {
        setIsInstallWidgetPopupOpen(false);
        document.body.classList.remove("popup-open");
    };

    // Function to copy code to clipboard
    const copyToClipboard = () => {
        const code = `<script src="${window.location.origin}/platform.js" async></script>
<div id="upgradeify-widget-app-${template.id}" data-upgradeify-widget-name="${template.uuid}"></div>`;

        navigator.clipboard.writeText(code).then(() => {
            setCopySuccess(true);

            // Hide tooltip after 2 seconds
            setTimeout(() => setCopySuccess(false), 2000);
        }).catch(err => {
            console.error("Failed to copy text: ", err);
        });
    };

    return (
        <div className="popup-overlay">
            <div className="popup-box">
                <h3>Install Widget</h3>
                <p>Copy and paste this code into the desired place on your website:</p>
                <pre className="code-box">
                    {`<script src="${window.location.origin}/platform.js" async></script>
<div id="upgradeify-widget-app-${template.id}" data-upgradeify-widget-name="${template.uuid}"></div>`}
                </pre>

                <div className="copy-btn-container">
                    <button onClick={copyToClipboard} className="copy-btn">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M13.067 5.733c1.03 0 1.866.836 1.866 1.867v5.467c0 1.03-.835 1.866-1.866 1.866H7.6a1.867 1.867 0 0 1-1.867-1.866V7.6c0-1.03.836-1.867 1.867-1.867Zm0 1.2H7.6a.667.667 0 0 0-.667.667v5.467c0 .368.299.666.667.666h5.467a.667.667 0 0 0 .666-.666V7.6a.667.667 0 0 0-.666-.667ZM8.436 1.067c.96 0 1.748.74 1.825 1.68l.006.15v.616a.6.6 0 0 1-1.192.097l-.008-.097v-.616a.63.63 0 0 0-.538-.623l-.093-.007H2.897a.63.63 0 0 0-.623.537l-.007.093v5.539a.63.63 0 0 0 .537.624l.093.007h.616a.6.6 0 0 1 .097 1.192l-.097.008h-.616a1.83 1.83 0 0 1-1.824-1.681l-.006-.15V2.897c0-.96.74-1.748 1.68-1.824l.15-.006h5.539Z"></path>
                        </svg>
                        Copy Code
                    </button>

                    {copySuccess && <span className="tooltip">Copied!</span>}
                </div>

                <button onClick={handleClosePopup} className="close-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="m3.855 3.022.083.07 6.059 6.056 6.06-6.057a.6.6 0 0 1 .917.766l-.07.083-6.059 6.057 6.06 6.058a.6.6 0 0 1-.766.918l-.083-.07-6.059-6.058-6.059 6.058a.6.6 0 0 1-.918-.765l.07-.083 6.058-6.058L3.09 3.94a.6.6 0 0 1 .673-.97l.092.052Z"></path>
                    </svg>
                </button>
            </div>
        </div>
    );
};

export default InstallWidgetPopup;